<aaa-modal
  contentMode="scroll"
  [isOpen]="true"
  [initialBreakpoint]="1"
  (aaaModalDidDismiss)="handleClose()"
  [handle]="false"
  [breakpoints]="[0, 1]"
>
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-align-items-center ion-justify-content-center">
        <aaa-button (click)="handleClose()"
                    class="close-button ion-float-left"
                    size="medium"
                    variant="on-map">
          <aaa-icon aria-hidden="true" name="close-outline"></aaa-icon>
        </aaa-button>
      <aaa-text size="headline" weight="medium" i18n>Facilities Preferences</aaa-text>
    </ion-row>
    <!-- Member Benefits Title -->
    <ion-row class="section-spacing">
      <ion-col>
        <aaa-text size="headline" weight="medium" i18n>Member Benefits</aaa-text>
      </ion-col>
    </ion-row>
    <!-- Member Benefits Card -->
    <ion-row>
      <ion-col>
        <ion-item class="savings-item">
          <ion-col size="auto" class="icon-col">
            <aaa-icon name="car" size="medium" color="medium"></aaa-icon>
          </ion-col>
          <ion-col>
            <aaa-text size="headline" weight="medium" i18n>Saving</aaa-text>
            <aaa-text size="caption" weight="regular" color="dark" display="flex" class="savings-label" i18n>
              Up to <aaa-text size="footnote" weight="semibold" color="valid" class="savings-off-label">{{savingsOffLabel()}}</aaa-text> Labor at AAA Approved Facilities.
            </aaa-text>
          </ion-col>
        </ion-item>
      </ion-col>
    </ion-row>
    <!-- Show Title -->
    <ion-row class="section-spacing">
      <ion-col>
        <aaa-text size="headline" weight="medium" i18n>Show</aaa-text>
      </ion-col>
    </ion-row>
    <!-- Show Card -->
    <ion-row>
      <ion-col>
        <ion-list class="ion-no-padding">
          <ion-item>
            <aaa-icon name="door" size="medium" color="medium" class="icon-col"></aaa-icon>
            <aaa-text size="headline" weight="medium" i18n>Open Now</aaa-text>
            <ion-toggle slot="end" [checked]="localPreferences.openNow === AAR_FILTER_TYPES.OPEN" color="drr-primary" aria-label="Toggle Open Now" i18n-aria-label (ionChange)="handleToggleOpenNow()"></ion-toggle>
          </ion-item>
          <div class="subtle-divider"></div>
          <ion-item lines="none">
            <aaa-icon name="car" size="medium" color="medium" class="icon-col"></aaa-icon>
            <ion-label>
              <aaa-text size="headline" weight="medium" i18n>Available Now</aaa-text>
              <aaa-text size="caption" weight="regular" color="dark" i18n>Ready to accept your vehicle</aaa-text>
            </ion-label>
            <ion-toggle slot="end" [checked]="localPreferences.availableNow" color="drr-primary" aria-label="Toggle Available Now" i18n-aria-label (ionChange)="handleToggleAvailableNow()"></ion-toggle>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <!-- Sort by Title -->
    <ion-row class="section-spacing">
      <ion-col>
        <aaa-text size="headline" weight="medium" i18n>Sort by</aaa-text>
      </ion-col>
    </ion-row>
    <!-- Sort by Card -->
    <ion-row>
      <ion-col>
        <ion-list class="ion-no-padding">
          <ion-item [lines]="hasRatings ? 'inset' : 'none'">
            <drr-checkbox
              [checked]="isSortedByDistance()"
              (change)="handleSortByDistance($event)"
            >
              <aaa-text size="headline" weight="medium" color="text" aria-label="Distance" i18n-aria-label i18n>Distance</aaa-text>
            </drr-checkbox>
          </ion-item>
          @if (hasRatings) {
            <div class="subtle-divider"></div>
            <ion-item lines="none">
              <drr-checkbox
                [checked]="isSortedByRating()"
                (change)="handleSortByRating($event)"
              >
                <aaa-text size="headline" weight="medium" color="text" aria-label="Member Rating" i18n-aria-label i18n>Member Rating</aaa-text>
              </drr-checkbox>
            </ion-item>
          }
        </ion-list>
      </ion-col>
    </ion-row>
    <!-- Buttons -->
    <ion-row class="button-row">
      <ion-col size="6" class="button-col">
        <aaa-button
          variant="secondary"
          expand="block"
          aria-label="Reset Filters"
          i18n-aria-label
          (click)="handleReset()"
          i18n
        >
          Reset Filters
        </aaa-button>
      </ion-col>
      <ion-col size="6" class="button-col">
        <aaa-button
          expand="block"
          variant="primary"
          aria-label="Apply Filters"
          i18n-aria-label
          (click)="handleApply()"
          i18n
        >
          Apply Filters
        </aaa-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</aaa-modal>
